<template>
  <router-view/>
</template>

<script>
  import RouteEntryMixin from '@com/mixins/route-entry'

  export default {
    name: 'settings',
    mixins: [RouteEntryMixin],
    data: _ => ({
      routes: [
        { path: '/settings/security', label: 'Security' }
      ]
    })
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/app/settings/Settings.Entry.vue